import { GlobeIcon } from '@sketchnote/icons';
import Tippy from '@tippyjs/react';
import React from 'react';

export const PublicTag = (): JSX.Element => {
  return (
    <div
      style={{ backgroundColor: '#211650' }}
      className="text-white py-4 px-8 flex bg-gray-500 rounded-sm text-xs  font-semibold"
    >
      <GlobeIcon wrapperClass="mt-3 mr-3" />
      <span>Public</span>
    </div>
  );
};
